import { events } from "@grindex-common/helpers/events";
import { addListener } from "@grindex-common/helpers/domManipulation";
import asyncModule from "@grindex-client/components/Module/asyncModule";

(function listenForEvent() {
	asyncModule("toggleswitch", events.TAB_ALL_LOADED, init);
})();

function init($views) {
	if (NodeList.prototype.isPrototypeOf($views)) {
		$views.forEach(($view) => {
			initView($view);
		});
	} else {
		initView($views);
	}

	function initView($view) {
		const CLASS_ON = "on";
		const CLASS_BTN_HOLDER = "btnHolder";

		const $toggleButton = $view.querySelector(`.${CLASS_BTN_HOLDER}`);

		initialize();

		function initialize() {
			addListener($toggleButton, "click", toggleSwitch);

			if (document.body.classList.contains("product-page")) {
				$toggleButton.dataset.isOn = $toggleButton.dataset.default === $toggleButton.dataset.on;

				updateToggleStatus($toggleButton);
			}
		}

		function isOn($toggler) {
			return $toggler.dataset.isOn === "true";
		}

		function updateToggleStatus() {
			if (isOn($toggleButton)) {
				$toggleButton.classList.add(CLASS_ON);
			} else {
				$toggleButton.classList.remove(CLASS_ON);
			}

			$toggleButton.dispatchEvent(new CustomEvent("toggle:changed"));
		}

		function toggleSwitch() {
			$toggleButton.dataset.isOn = $toggleButton.dataset.isOn === "true" ? "false" : "true";
			updateToggleStatus($toggleButton);
		}
	}
}

export default {
	view: "toggleswitch",
	init,
};
